import React, {useState} from 'react';
import PropTypes from 'prop-types';
import isMobile from 'ismobilejs';

const FullscreenButton = ({ shown }) => {
    const [fullscreen, setFullscreen] = useState(false);
    const classnames = ['fullscreen-button'];

    if (fullscreen) classnames.push('fullscreen');
    if (shown) classnames.push('shown');

    const toggleFullscreen = () => {

        if (!window.document.fullscreenElement) {
            setFullscreen(true);
            window.document.documentElement.requestFullscreen();
        } else {
            setFullscreen(false);
            window.document.exitFullscreen();
        }
    };

    if (isMobile.android.phone) {
        return <button className={classnames.join(' ')} onClick={toggleFullscreen} />
    } else return null;
};

FullscreenButton.propTypes = {
    shown: PropTypes.bool.isRequired
};

export default FullscreenButton;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/FullscreenButton/index.js